const COMPANION_PORT_KEY = "tpe_companion_port";
const COMPANION_TOKEN_KEY = "tpe_companion_token";

export interface CompanionSettings {
  port: number;
  token: string;
}

export function getCompanionSettings() {
  const port = Number(localStorage.getItem(COMPANION_PORT_KEY) || "0");
  const token = localStorage.getItem(COMPANION_TOKEN_KEY) || "";
  return { port, token };
}

export function saveCompanionSettings(settings: CompanionSettings) {
  localStorage.setItem(COMPANION_PORT_KEY, String(settings.port));
  localStorage.setItem(COMPANION_TOKEN_KEY, settings.token);
}

export type CompanionErrorCode =
  | "companion_unreachable"
  | "not_paired"
  | "terminal_busy"
  | "terminal_not_configured"
  | "terminal_unreachable"
  | "invalid_request"
  | "not_found"
  | "unknown";

export class CompanionError extends Error {
  code: CompanionErrorCode;
  activePaymentId?: string;

  constructor(code: CompanionErrorCode, message: string, activePaymentId?: string) {
    super(message);
    this.name = "CompanionError";
    this.code = code;
    this.activePaymentId = activePaymentId;
  }
}

export async function companionRequest(path: string, init?: RequestInit) {
  const settings = getCompanionSettings();
  if (!Number.isInteger(settings.port) || settings.port < 1 || settings.port > 65535) {
    throw new CompanionError(
      "not_paired",
      "Le port de l'API locale du Companion doit être configuré (1 à 65535) dans Menu → Règlements TPE du jour → Réglages companion.",
    );
  }
  if (!settings.token.trim()) {
    throw new CompanionError(
      "not_paired",
      "Renseignez le token d'appairage dans Menu → Règlements TPE du jour → Réglages companion. Le port et le token sont communs au TPE et à la lecture Vitale.",
    );
  }

  try {
    return await fetch(`http://127.0.0.1:${settings.port}${path}`, {
      ...init,
      headers: {
        "content-type": "application/json",
        authorization: `Bearer ${settings.token}`,
        ...init?.headers,
      },
    });
  } catch (caught) {
    if (init?.signal?.aborted) throw caught;
    throw new CompanionError(
      "companion_unreachable",
      "Companion injoignable. Lancez-le sur ce poste et vérifiez le port et le token dans Menu → Règlements TPE du jour → Réglages companion.",
    );
  }
}
